import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HiX, HiOutlineMail } from 'react-icons/hi';
import { authAPI } from '../services/api';
import { getErrorMessage } from '../utils/errorHandler';
import toast from 'react-hot-toast';

function ForgotPasswordModal({ onClose }) {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error(t('auth.enterEmail'));
      return;
    }

    setLoading(true);
    try {
      await authAPI.forgotPassword(email);
      toast.success(t('auth.emailSentIfRegistered'));
      onClose();
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{t('auth.forgotPasswordTitle')}</h2>
          <button className="modal-close" onClick={onClose}>
            <HiX />
          </button>
        </div>

        <div className="modal-body">
          <p style={{ marginBottom: '16px', color: 'var(--text-secondary)', lineHeight: '1.6' }}>
            {t('auth.forgotPasswordDescription')}
          </p>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">{t('common.email')}</label>
              <div style={{ position: 'relative' }}>
                <HiOutlineMail
                  style={{
                    position: 'absolute',
                    left: '16px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: 'var(--text-muted)',
                  }}
                />
                <input
                  type="email"
                  className="form-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t('auth.enterRegisteredEmail')}
                  style={{ paddingLeft: '48px' }}
                  required
                />
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
                disabled={loading}
              >
                {t('common.cancel')}
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? t('auth.sending') : t('auth.sendInstructions')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordModal;
